import type { DateRangeKey } from './eventDates';

/**
 * The events list filtered as a count elsewhere was counted — the one way a
 * number ("12 events at this venue", "Upcoming (30d)") opens the events it
 * names. The parameters are the ones `EventsPage` reads from the address.
 */
export interface EventListFilters {
  range?: DateRangeKey;
  /** `'all'` is every status, cancelled included. Absent is the range's default. */
  statuses?: readonly string[] | 'all';
  typeIds?: readonly string[];
  venueIds?: readonly string[];
  vendorIds?: readonly string[];
}

export function eventsListPath(filters: EventListFilters = {}): string {
  const params = new URLSearchParams();
  // `upcoming` is the page's own default, so it never needs saying.
  if (filters.range && filters.range !== 'upcoming') params.set('range', filters.range);
  if (filters.statuses === 'all') params.set('status', 'all');
  else if (filters.statuses?.length) params.set('status', filters.statuses.join(','));
  if (filters.typeIds?.length) params.set('type', filters.typeIds.join(','));
  if (filters.venueIds?.length) params.set('venue', filters.venueIds.join(','));
  if (filters.vendorIds?.length) params.set('vendor', filters.vendorIds.join(','));
  const query = params.toString();
  return query ? `/events?${query}` : '/events';
}
